var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _line, _line2, _line3, _circle3, _circle4, _rect, _line4, _line5, _line6, _line7, _line8, _line9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 636.58 471.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:3px;}.b,.c{stroke:#8ecae6;}.b,.c,.d,.e{fill:none;stroke-miterlimit:10;}.c,.d,.e{stroke-width:4px;}.d{stroke:#219ebc;}.e{stroke:#fb8500;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M161.52,321.13V109.89s-4.46-37.8,40.54-37.8h213.65l54.89,50.31-.49,219.08-34.22-20.35-34.05,20.35-34.22-20.35-34.22,20.35-34.17-20.35-33.65,19.88-34.83-19.88-34.7,20.35-34.54-20.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M161.52,368.07v-26.59l34.54,20.54,34.7-20.54,34.26,20.54,34.22-20.54,34.17,20.54,34.22-20.54,34.22,20.54,34.05-20.54,34.22,20.54v91.67s0,15.89-23.08,15.89c-25.94,0-257.63,.27-257.63,.27,0,0-27.88,2.33-27.88-27.33v-74.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M274.24,265.41s36.48-40.85,83.16,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M414.67,73.91l.15,34.9s-1.62,12.36,14.94,11.88c14.08-.41,37.8,0,37.8,0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 245.05,
    cy: 183.06,
    r: 11.61
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 387.7,
    cy: 183.06,
    r: 11.61
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 85.48,
    y1: 62.85,
    x2: 139.4,
    y2: 74.73
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 102.41,
    y1: 19.77,
    x2: 147.98,
    y2: 59.24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 142.91,
    y1: 0.72,
    x2: 161.15,
    y2: 47.88
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 544.77,
    cy: 294.03,
    r: 33.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 544.24,
    cy: 294.57,
    r: 47.52
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 595.44,
    y: 329,
    width: 24.84,
    height: 59.92,
    rx: 10.44,
    ry: 10.44,
    transform: "translate(-75.78 534.96) rotate(-45)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 1.31,
    y1: 321.13,
    x2: 48.66,
    y2: 362.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 48.66,
    y1: 321.13,
    x2: 1.31,
    y2: 362.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5.86,
    y1: 444.69,
    x2: 132.22,
    y2: 444.69
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 52.84,
    y1: 468.93,
    x2: 154.06,
    y2: 468.93
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 510.22,
    y1: 444.69,
    x2: 636.58,
    y2: 444.69
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 491.86,
    y1: 468.93,
    x2: 510.22,
    y2: 468.93
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.9ce32286eedc406c52f58f7e789415f0.svg";
export { ForwardRef as ReactComponent };